import { messages as messagesEN } from './en';

export const messages: typeof messagesEN = {
  HOME: { TITLE: 'accueil', ROUTE: '/home' },
  ABOUT: { TITLE: "À propos de l'application", ROUTE: '/about' },
  DEFINE_BOX: { TITLE: 'Boîte morphologique', ROUTE: '/define' },
  SETTINGS: { TITLE: 'Paramètres', ROUTE: '/settings' },
  CREATE_SCENARIO: { TITLE: 'Créer un scénario', ROUTE: '/create' },
  SHOW_SCENARIO: { TITLE: 'Afficher les scénarios', ROUTE: '/show' },
  DECISION_SUPPORT: { TITLE: 'Aide à la décision', ROUTE: '/decide' },
  DOWNLOAD: {
    COLLECTION: 'Enregistrer la collection',
    MODEL: 'Enregistrer le fichier de boîte',
  },
  DOWNLOAD_FILENAME_TITLE: 'Enregistrer le fichier de boîte',
  DOWNLOAD_FILENAME_LABEL: 'Nom du fichier',
  UPLOAD: {
    COLLECTION: 'Charger la collection',
    MODEL: 'Charger le fichier de boîte',
  },
  OPEN_MENU: 'Ouvrir le menu',
  UPLOAD_FILE: 'Charger une boîte ou une collection',
  IMPORT_READ_ERROR: 'Impossible de lire le fichier sélectionné.',
  COLLECTION_LOAD_FAILED: 'Impossible de charger la collection. Vérifiez votre connexion et actualisez la page.',
  STARTER_KIT_LOAD_FAILED: 'Impossible de charger le kit de démarrage. Vérifiez votre connexion et réessayez.',
  IMPORT_COLLECTION_TITLE: 'Remplacer la collection ?',
  IMPORT_COLLECTION_MSG:
    'Ce fichier contient une collection. Son chargement remplacera votre collection actuelle, y compris les modifications non enregistrées. Continuer ?',
  CANCEL: 'Annuler',
  DELETE: 'Supprimer',
  AND: 'et',
  YES: 'Oui',
  NO: 'Non',
  OK: 'Ok',
  NAME: 'Nom',
  DESCRIPTION: 'Description',
  NEW_BOX: 'Nouvelle boîte morphologique',
  CATEGORIES: 'Catégories',
  DIMENSION: 'Facteur clé',
  DIMENSION_SELECTED: 'Facteurs sélectionnés',
  DIMENSIONS: 'Facteurs',
  KEY_VALUE: 'Valeur clé',
  OPTION_USAGE_LEGEND: 'Utilisation des options dans les scénarios inclus',
  OPTION_USAGE_RANGE: 'Utilisée {range} fois dans les scénarios inclus',
  OPTION_USAGE_COUNT: 'utilisée {count} fois',
  CONTEXT: 'Contexte',
  NONE: 'Aucun',
  LOCATION: 'Localisation',
  LOCATION_TYPE: 'Type de localisation',
  COORDINATES: 'Coordonnées',
  LOCATION_NAME: 'Nom du lieu',
  LATITUDE: 'Latitude',
  LONGITUDE: 'Longitude',
  MANUAL: 'Mode manuel',
  Type: 'Type',
  PICK_FROM_LIST: 'Choisir dans la liste',
  ENTER_KEY_VALUE: 'Saisir la valeur clé',
  EDIT_COMPONENT: 'Modifier le composant',
  ADD_COMPONENT: 'Ajouter un composant',
  GENERATE_NARRATIVE: 'Générer',
  CLEAR_NARRATIVE: 'Effacer',
  NAME_NARRATIVE: 'Titre du scénario actuel',
  SAVE_NARRATIVE: 'Enregistrer',
  SAVED_NARRATIVES: 'Scénarios enregistrés',
  HOME_WORK_TITLE: "Choisir un type de scénario",
  HOME_WORK_HINT: "Commencez avec un type de scénario prêt à l’emploi du kit de démarrage, puis créez et comparez vos scénarios.",
  HOME_OPTIONS_TITLE: "Adapter ou créer le vôtre",
  HOME_EDIT_CARD_TITLE: "Adapter un type de scénario",
  HOME_EDIT_CARD_DESC: "Ajoutez, modifiez ou supprimez des facteurs et des options pour que le type choisi corresponde à votre situation.",
  HOME_AI_CARD_TITLE: "Créer un nouveau type de scénario",
  HOME_AI_CARD_DESC: "Laissez l’IA proposer une boîte morphologique pour votre sujet, ou commencez vous-même avec une boîte vide.",
  HOME_MAP_CARD_TITLE: "Scénarios sur la carte",
  HOME_MAP_CARD_DESC: "Votre scénario se déroule-t-il dans des lieux identifiables, comme une centrale nucléaire ou un monument ? Activez la carte, ouvrez Modifier la boîte et ajoutez, via le crayon d’une option, des coordonnées ou un type de lieu. Ces lieux apparaissent alors sur la carte de vos scénarios.",
  HOME_MAP_CARD_ENABLE: "Activer la carte",
  HOME_MAP_CARD_ENABLED: "La carte est activée. Ajoutez des lieux aux options via Modifier la boîte.",
  TUTORIAL_CARD_TITLE: "Tutoriel",
  TUTORIAL_CARD_DESC: "Découvrez comment générer un scénario complet en une fois avec un assistant IA : récit, réflexions sur les options d'action et retours des personas.",
  TUTORIAL_WATCH: "Voir le tutoriel",
  TUTORIAL_TITLE: "Tutoriel : un scénario complet avec l'IA",
  TUTORIAL_DESC: "Du kit de démarrage à la décision : générez un scénario, laissez un assistant IA rédiger le récit, les réflexions et les retours des personas en JSON, collez-le et analysez les résultats.",
  TUTORIAL_NARRATION: "Langue de la narration",
  HOME_MAP_CARD_ACTIVE: "La carte est activée pour ce type de scénario.",
  HOME_MAP_CARD_LOCATIONS: "Ajouter des lieux",
  DECISION_BANNER_MSG: "Ce type de scénario contient des mesures pour l’aide à la décision. Activez-la pour choisir des mesures, comparer des options d’action et consigner des décisions.",
  DECISION_HELP_TITLE: "Comment fonctionne l’aide à la décision ?",
  DECISION_HELP_STEP1: "Dans Créer un scénario, décrivez la situation : choisissez les facteurs de l’incident et enregistrez le scénario.",
  DECISION_HELP_STEP2: "Sous Décisions, choisissez les mesures adaptées à la situation. Chaque ensemble de mesures est une option d’action ; créez-en plusieurs pour comparer des alternatives.",
  DECISION_HELP_STEP3: "Estimez pour chaque option d’action la probabilité et l’impact résiduels.",
  DECISION_HELP_STEP4: "Comparez ici les options d’action dans l’aperçu, la comparaison, la vue de robustesse et la matrice des risques.",
  DECISION_HELP_STEP5: "Consignez la décision et sa justification dans le journal des décisions, puis exportez l’ensemble vers Word.",
  PERSONA_CLIPBOARD_HINT: "Aucun modèle de langage n’est connecté : le bouton copie donc une invite. Collez-la dans le chat de votre assistant IA, puis collez la réponse dans le champ de retour du persona. Connectez un modèle de langage dans Paramètres → LLM pour générer le retour directement.",
  SETUP_LLM: "Configurer le modèle de langage",
  NARRATIVE_PROMPT_COPIED: "Invite de récit copiée. Collez-la dans le chat de votre assistant IA, puis collez la réponse dans le champ du récit.",
  EDIT_BOX: 'Modifier la boîte',
  NO_SAVED_NARRATIVES: 'Aucun scénario enregistré dans cette boîte. Créez-en un pour commencer.',
  NO_MATCHING_NARRATIVES: 'Aucun scénario ne correspond à cette recherche.',
  OPEN_SCENARIO: 'Ouvrir le scénario',
  COMPARE_SCENARIOS: 'Comparer les scénarios',
  HIDE_COMPARISON: 'Masquer la comparaison',
  BOX_ACTIONS: 'Autres actions',
  PERMALINK: 'Copier le permalien',
  PERMALINK_COPIED: 'Permalien copié dans le presse-papiers. Collez-le dans un e-mail pour partager cette boîte.',
  PERMALINK_COPIED_LONG: 'Permalien copié, mais il est très long : certains clients de messagerie peuvent le couper. Envoyez plutôt le fichier téléchargé.',
  PERMALINK_INVALID: 'Le lien partagé est invalide ou incomplet.',
  COLLECTION_ACTIONS: 'Gestion de la collection',
  LANGUAGE_NAMES: {
    nl: 'Nederlands', en: 'English', fr: 'Français',
    de: 'Deutsch', es: 'Español', pl: 'Polski',
  },
  FILTER_NARRATIVES: 'Filtrer les scénarios',
  FILTER_NARRATIVES_PLACEHOLDER: 'Tapez pour filtrer par nom...',
  NARRATIVE: 'scénario',
  INCLUDE_NARRATIVE: "Sélectionner pour l'analyse",
  NARRATIVE_INCLUDED: "Sélectionné pour l'analyse",
  SELECT_NARRATIVE: 'Sélectionner un scénario',
  SELECT_SCENARIO: "Type de scénario",
  SELECT_GROUP_OWN: "Mes types de scénario",
  SELECT_GROUP_STARTER: "Kit de démarrage",
  KEY: 'Clé',
  VALUE: 'Valeur',
  MODEL: 'Modèle',
  SELECTION: 'Valeur sélectionnée',
  EDITOR_PLACEHOLDER: 'Modifier le scénario',
  THRESHOLDS: 'Couleurs de seuils reflétant les options des composants',
  THRESHOLD: 'Valeur de seuil',
  COLOR: 'Couleur',
  ORDER: 'Ordre',
  COMBINATIONS: {
    POSSIBLE: 'Les combinaisons sont possibles',
    IMPOSSIBLE: 'Les combinaisons sont impossibles',
    IMPROBABLE: 'Les combinaisons sont improbables',
  },
  DELETE_ITEM: {
    title: 'Supprimer {item}',
    description:
      'Êtes-vous certain de vouloir supprimer cet(te) {item} ? Cette action est irréversible.',
  },
  NEW_SCENARIO: 'Nouvelle boîte',
  ADD_STARTER_KIT: 'Ajouter ou mettre à jour le kit de démarrage',
  ADD_STARTER_KIT_HINT: "Ajoute les boîtes et personas manquants et met à jour ceux qui n'ont pas été modifiés. Les éléments modifiés ne sont remplacés qu'après votre confirmation.",
  STARTER_KIT_ADDED: 'Kit de démarrage : {added} ajoutés, {updated} mis à jour.',
  STARTER_KIT_CONFLICT_TITLE: 'Écraser les éléments modifiés ?',
  STARTER_KIT_CONFLICT_MSG: 'Vous avez modifié ces éléments du kit. Sélectionnez ceux à remplacer par la version actuelle du kit de démarrage. Vos modifications, y compris les récits et les décisions, seront perdues. Les éléments non sélectionnés restent inchangés.',
  STARTER_KIT_SELECT_ALL: 'Tout sélectionner',
  STARTER_KIT_UPDATE: 'Mettre à jour',
  STARTER_KIT_KIND_BOX: 'boîte',
  STARTER_KIT_KIND_PERSONA: 'persona',
  STARTER_KIT_ALREADY_PRESENT: 'Le kit de démarrage est déjà à jour.',
  NEW_MODEL: {
    btn: 'Nouvelle collection',
    title: 'Choisir une nouvelle collection',
    description:
      'Votre collection actuelle sera remplacée. Téléchargez-la d’abord si vous souhaitez la conserver.',
    choose: 'Choisissez votre nouvelle collection',
  },
  DELETE_MODEL: {
    btn: 'Supprimer la boîte',
    title: 'Supprimer la boîte sélectionnée',
    description:
      'Supprimer cette boîte et ses scénarios enregistrés ? Cette action est irréversible.',
  },
  INCONSISTENCIES: {
    title: 'Incohérences',
    SELECT_ROW_CATEGORY: 'Sélectionner la catégorie de ligne',
    SELECT_COLUMN_CATEGORY: 'Sélectionner la catégorie de colonne',
    SELECT_CATEGORIES_TO_START: 'Sélectionner les catégories pour commencer',
    NO_DRIVERS:
      "Aucun facteur clé avec des valeurs n'est disponible pour cette combinaison de catégories",
    NAV_TITLE: 'Navigation clavier',
    NAV_ARROWS:
      'Flèches: naviguer entre les cellules, avec Shift entre facteurs clés',
    NAV_TOGGLE: "Espace ou Entrée: changer l'état de la combinaison",
    NAV_SHIFT_VERTICAL:
      'Shift + Haut/Bas: changer le facteur clé de ligne actif',
    NAV_SHIFT_HORIZONTAL:
      'Shift + Gauche/Droite: changer le facteur clé de colonne actif',
  },
  saveButton: {
    label: 'Enregistrer',
    tooltip: 'Enregistrer les modifications non sauvegardées',
  },
  i18n: {
    /** Label for the edit button of the RepeatList */
    editRepeat: 'Modifier',
    /** Label for the create button of the RepeatList */
    createRepeat: 'Ajouter',
    /** Label for the delete button of the RepeatList */
    deleteItem: 'Supprimer',
    /** Label for the agree button of the RepeatList */
    agree: 'Oui',
    /** Label for the disagree button of the RepeatList */
    disagree: 'Non',
    /** Pick */
    pick: 'Choisir',
    /** Pick one */
    pickOne: 'Choisir un',
    /** Pick one or more */
    pickOneOrMore: 'Choisir un ou plusieurs',
    /** Cancel button text */
    cancel: 'Annuler',
    /** Save button text */
    save: 'Enregistrer',
  },
  COMP: {
    AVAILABLEBUDGET: 'Budget',
    BEHAVIOURDURINGPREPARATION: 'Comportement pendant la préparation',
    CAPABILITIES: 'Capacité',
    COMPARTMENTSPRESENT: 'Compartiments présents',
    CRIMINALPHASE: 'Phase criminelle',
    DURATION: 'Durée',
    EQUIPMENT: 'Équipement',
    EXISTINGINFRA: 'Infrastructure existante',
    IMPACT: 'Impact',
    INTENT: 'Intention du témoin',
    LOCATION: 'Localisation',
    LOCATION2: 'Localisation',
    MODUSOPERANDIDURINGEXECUTION: 'Mode opératoire',
    MOTIVATION: 'Motivation',
    NARRATIVE: 'Récit',
    NARRATIVE_PLACEHOLDER:
      "Décrivez le contexte dans lequel l'incident a eu lieu, comme une description de la localisation (géographique), la personne ou le bâtiment qui doit être protégé, la manière dont un acteur obtient des informations, à quel moment l'action a eu lieu, dans quelles circonstances météorologiques, combien de personnes étaient impliquées dans l'action, de quelle organisation, comment ont-elles obtenu l'accès, ou quels moyens/armes ont été employés.",
    OBJECT: 'Objet',
    OPENCOMPARTMENTS: 'Compartiment ouvert',
    PEOPLEDENSITY: 'Densité de personnes',
    PERSONS: 'Personne',
    PHYSICALANGLEOFATTACKDURINGEXECUTION: "Angle d'attaque physique",
    PHYSICAL_ANGLE: 'Angle physique',
    PRIVACYAWARENESS: 'Sensibilisation à la vie privée',
    RELATIONOWNEROBJECTANDOWNERSECURITYSYSTEM:
      "Relation entre le propriétaire de l'objet et le propriétaire du système de sécurité",
    RESPONSIBILITY: 'Responsabilité',
    SCENARIOS: 'Scénario',
    SECURITYAWARENESS: 'Sensibilisation à la sécurité',
    TARGETTYPE: 'Type de cible',
    THREATDIRECTION: 'Direction de la menace',
    ACTOR: 'Acteur',
    ACTION: 'Action',
    ACCESS: 'Accès',
    MEANS: 'Moyens',
    TYPEOFENVIRONMENT: "Type d'environnement",
    TYPEOFOBJECT: "Type d'objet",
    WEAPON: 'Arme',
    WEATHERBEHAVIOUR: 'Comportement météorologique',
    WEATHERTYPE: 'Condition météorologique',
    PI: 'Intérêt protégé (cible)',
    MEANSWEAPON: 'Moyens/arme',
    MISSIONCONTEXT: 'Contexte de la mission',
    ADVERSARY: 'Adversaire',
    C2HEADQUARTERS: 'Localisation du PC C2',
    TARGET: 'Cible',
    DELIBERATEACTION: 'Action délibérée',
    MEANS2: "Moyens d'attaque",
    MEANS3: "Moyens pour l'action",
    MEANS4: "Moyens pour l'accès",
    ACCESS2: "Moyens d'accès",
    MEANS2ACCESS: "Moyens d'accéder",
  },
  MODEL_NAMES: {
    0: 'Modèle vide',
    1: 'Kit de démarrage',
  },
  MODEL_DESC: {
    0: 'Commencer avec une boîte morphologique vide.',
    1: 'Dix boîtes d’exercice en français avec exemples, contraintes, modèles de récit et invites LLM.',
  },
  JSON_NOT_VALID: "Le fichier de modèle JSON n'est pas valide ! Annulation.",
  NO_NARRATIVE: 'Aucun scénario généré après 100 tentatives !',
  ALL_LOCKED_WARNING:
    "Tous les composants sont verrouillés — aucun nouveau scénario ne peut être généré. Effacez d'abord le scénario actuel.",
  SPEC_CATS:
    "Spécifiez d'abord quelques catégories, où chaque catégorie contient des facteurs clés.",
  TRANSPOSE_BOX: {
    COLUMNS: 'Afficher les facteurs clés en colonnes',
    ROWS: 'Afficher les facteurs clés en lignes',
  },
  EXPORT2WORD: {
    TITLE: 'Exporter vers Word',
    DESC: 'Quel scénario voulez-vous exporter ?',
    CURRENT: 'Actuel',
    SELECTED: 'Sélectionné',
    ALL: 'Tous',
    INCLUDE_BOX: 'Inclure la boîte morphologique (un tableau par catégorie, valeurs sélectionnées mises en évidence)',
    INCLUDE_DECISIONS: "Inclure l'analyse décisionnelle (aperçu, comparaison des options d'action, matrice des risques et journal des décisions)",
  },
  HIDE_INCONSISTENT: 'Masquer les combinaisons incohérentes',
  GOAL: {
    TITLE: 'Objectif',
    DESC: 'ScenarioSpark est une application web qui peut être utilisée pour créer et gérer systématiquement un ensemble de scénarios pour les activités de gestion des risques.',
  },
  USAGE: {
    TITLE: 'Utilisation',
    DESC: "ScenarioSpark aide l'utilisateur à créer et compiler un ensemble représentatif de scénarios qui peuvent être utilisés dans les différentes étapes du processus de gestion des risques.",
  },
  SECURITY: {
    TITLE: 'Sécurité',
    DESC: 'Toutes les informations utilisées et saisies sont traitées et stockées exclusivement en local.',
  },
  SUMMARY:
    "Un outil gratuit pour vous aider à créer de nouveaux scénarios en utilisant une boîte morphologique. D'abord, vous définissez les aspects qui sont d'intérêt dans votre domaine. Ensuite, vous spécifiez les variations pour chaque aspect. Et enfin, vous créez manuellement de nouveaux scénarios ou vous vous inspirez en générant automatiquement des scénarios possibles.",
  SET_LANGUAGE: 'Définir la langue',
  SCENARIO_LOADED_MSG: 'Boîte chargée',
  COLLECTION_LOADED_MSG: 'La collection de boîtes est chargée',
  SCENARIO_NOT_LOADED_MSG:
    "La boîte n'a pas été chargée : elle est peut-être déjà dans la collection.",
  IMPORT_CONFLICT_TITLE: 'La boîte existe déjà',
  IMPORT_CONFLICT_MSG:
    'Une boîte nommée "{name}" est déjà dans votre collection. Que voulez-vous faire ?',
  IMPORT_OVERWRITE: 'Écraser',
  IMPORT_AS_COPY: 'Ajouter en copie',
  SCENARIO_CREATED_MSG: 'Boîte créée',
  COPY_TO_CLIPBOARD: 'Copier le tableau dans le presse-papiers',
  GROUP: {
    SELECTED: 'Scénarios sélectionnés',
    UNSELECTED: 'Scénarios non sélectionnés',
  },
  MORE_ACTIONS: "Plus d'actions",
  CLONE_NARRATIVE: 'Cloner',
  INCLUDE_DECISION_SUPPORT: "Activer l'aide à la décision",
  IS_DECISION_CATEGORY: "Pour l'aide à la décision",
  DECISION_CATEGORY_HINT: "Les facteurs d'une catégorie de décision sont manuels : ils ne sont pas générés, vous les choisissez après avoir décrit la situation. Les catégories de décision ne sont affichées que si l'aide à la décision est activée.",
  DECISION_CATEGORIES_HIDDEN: "Les catégories de décision ({count}) sont masquées.",
  DECISION_CATEGORIES_OPEN_SETTINGS: "Ouvrir les Paramètres",
  DECISIONS: "Décisions",
  DECISIONS_HINT: "Choisissez les mesures adaptées à la situation ci-dessus. Les options incompatibles avec la situation sont grisées.",
  EXCLUDED_BY: "exclu par {situation}",
  COURSES_OF_ACTION: "Modes d'action",
  COURSE_OF_ACTION: "Mode d'action",
  COA_ACTIVE: "actif",
  ADD_COA: "Ajouter",
  DUPLICATE_COA: "Dupliquer",
  RENAME_COA: "Renommer le mode d'action",
  DELETE_COA: "Supprimer le mode d'action",
  COA_NAME: "Nom du mode d'action",
  COA_NOTES: "Notes sur ce mode d'action",
  COA_HAS_CONFLICTS: "Contient des mesures incompatibles avec la situation",
  COA_CONFLICT: "{value} est incompatible avec la situation ({situation})",
  REFLECT_ON_DECISIONS: "Demander au LLM : réfléchir aux décisions",
  COA_REFLECTION: "Réflexion sur ce mode d'action",
  DECISION_PROMPT_COPIED: "Invite de décision copiée. Collez-la dans le chat de votre assistant IA, puis collez la réponse dans le champ de réflexion.",
  DECISION_REFLECTION_ERROR: "Impossible de générer ou de copier la réflexion. Réessayez.",
  DECISION_REFLECTION_DISCARDED: "La réflexion n'a pas été enregistrée : le scénario ou le mode d'action a changé pendant sa génération.",
  NO_DECISION_CATEGORIES: "Cette boîte n'a pas de catégorie de décision. Marquez une catégorie comme « Pour l'aide à la décision » dans les paramètres pour comparer des mesures ici.",
  DECISION_VIEW_OVERVIEW: "Vue d'ensemble",
  DECISION_VIEW_COA: "Comparer les modes d'action",
  DECISION_VIEW_ROBUSTNESS: "Robustesse",
  COMPARE_SCENARIO: "Scénario à comparer",
  SHOW_DIFFERENCES_ONLY: "Afficher uniquement les différences",
  NO_INCLUDED_NARRATIVES: "Aucun scénario n'est encore sélectionné pour l'analyse. Sélectionnez des scénarios sur la page Créer un scénario pour les comparer ici.",
  NO_CURRENT_NARRATIVE: "Aucun scénario n'est ouvert. Ouvrez ou enregistrez d'abord un scénario sur la page Créer un scénario.",
  NO_COAS: "Ce scénario n'a pas encore de mode d'action. Ajoutez-en sur la page Créer un scénario.",
  NO_COA_DIFFERENCES: "Tous les modes d'action choisissent les mêmes mesures.",
  NO_DECISION_SELECTED: "aucune",
  ROBUSTNESS_HINT: "Quelles mesures tiennent dans le scénario actuel et ceux sélectionnés pour l'analyse ? Chaque colonne est un scénario avec son mode d'action actif ; une mesure choisie dans tous les scénarios est une première étape sûre, une mesure choisie dans un seul scénario dépend de l'évolution de la situation.",
  ROBUSTNESS_ONE_SCENARIO: "La robustesse compare deux scénarios ou plus. Enregistrez un autre scénario sur la page {page} et sélectionnez-le pour l'analyse afin de voir quelles mesures tiennent dans tous les scénarios.",
  SCENARIO_CURRENT: "actuel",
  ROBUSTNESS_MEASURE: "Mesure",
  ROBUSTNESS_CHOSEN: "Choisie",
  ROBUSTNESS_EXCLUDED: "Exclue par la situation",
  ROBUSTNESS_UNUSED: "Non utilisée",
  ROBUSTNESS_CHOSEN_IN: "Choisie dans",
  ROBUSTNESS_COUNT: "{count} sur {total}",
  ROBUSTNESS_ROBUST: "Robuste : choisie dans chaque scénario",
  ROBUSTNESS_SPECIFIC: "Propre à un scénario : choisie dans un seul scénario",
  SUGGESTED_WHY: "Pourquoi cette suggestion",
  SUGGESTED_HINT: "Par facteur, les mesures ayant le score pondéré par le risque le plus élevé sur les modes d'action actifs. Les mesures impossibles dans chaque situation comparée, ou avec un choix plus fort, sont ignorées ; les combinaisons improbables sont autorisées, vérifiez-les donc vous-même.",
  SUGGESTED_PICK: "choisi dans {count} scénarios sur {total}, poids {weight}",
  SUGGESTED_SKIPPED_EXCLUDED: "{value} ignoré : impossible dans chaque situation comparée ({causes})",
  SUGGESTED_SKIPPED_CONFLICT: "{value} ignoré : impossible avec {causes}",
  SUGGESTED_NONE: "Aucune suggestion : aucun scénario n'a choisi de mesure",
  SUGGESTED_NONE_EXCLUDED: "Aucune suggestion : chaque mesure choisie est impossible dans toutes les situations comparées",
  SUGGESTED_NONE_CONFLICT: "Aucune suggestion : chaque mesure choisie est impossible avec un choix plus fort",
  RESIDUAL_PROBABILITY: "Probabilité après ce mode d'action",
  RESIDUAL_IMPACT: "Impact après ce mode d'action",
  RESIDUAL_RISK: "Risque résiduel",
  COA_RISK_HINT: "Facultatif : estimez le risque qui subsiste lorsque cette option d'action est mise en œuvre. Il est comparé au risque de la situation.",
  SITUATION_RISK_HINT: "Risque de la situation sans intervention : la probabilité qu'elle s'aggrave ou cause des dommages (supplémentaires), et l'impact le cas échéant.",
  RISK_DOWN_FROM: "En baisse par rapport à {before}",
  RISK_UP_FROM: "En hausse par rapport à {before}",
  RISK_SAME_AS: "Identique à la situation ({before})",
  COA_RISK_SUMMARY: "Risque résiduel : {after} (situation : {before})",
  COA_RISK_SUMMARY_SHORT: "Risque résiduel : {after}",
  RISK_BEFORE_AFTER: "Risque : situation → après le mode d'action",
  RISK_TRANSITION: "{before} → {after}",
  RISK_CHANGE: { lower: "Risque plus faible", same: "Risque identique", higher: "Risque plus élevé" },
  RISK_NOT_SET: "non renseigné",
  DECISION_VIEW_RISK: "Matrice des risques",
  RISK_MATRIX_CAPTION: "Matrice des risques : probabilité (lignes) × impact (colonnes)",
  RISK_MATRIX_HINT: "Les chiffres sont le scénario actuel (1) et ceux sélectionnés pour l'analyse (risque de la situation) ; les lettres sont les modes d'action du scénario sélectionné (risque résiduel).",
  RISK_MATRIX_MARKER: "Repère",
  RISK_MATRIX_ITEM: "Scénario ou mode d'action",
  RISK_MATRIX_CELL: "Probabilité {probability}, impact {impact} : risque {risk}",
  RISK_MATRIX_LEGEND: "Niveau de risque",
  RISK_LEVEL_HINT: { 0: 'Acceptable ; aucune mesure supplémentaire nécessaire.', 1: 'Acceptable ; surveiller la situation.', 2: 'Réduire le risque dans la mesure du raisonnable.', 3: 'Inacceptable ; mesures prioritaires nécessaires.', 4: 'Inacceptable ; agir immédiatement.' },
  RISK_MATRIX_UNPLACED: "Non placés (probabilité ou impact non renseigné) : {items}",
  RISK_MATRIX_EMPTY: "Renseignez la probabilité et l'impact des scénarios inclus pour les placer.",
  CRITERIA_SCORING: "Notation par critères (facultatif)",
  CRITERIA_HINT: "Notez chaque mode d'action par critère de 1 (faible) à 5 (bon) et indiquez le poids de chaque critère (0 = ignorer). Le score pondéré est la somme poids × note.",
  CRITERIA: { effect: "Efficacité", speed: "Rapidité", capacity: "Capacité", safety: "Sécurité des intervenants", legality: "Légalité", acceptance: "Acceptation par le public" },
  CRITERIA_CRITERION: "Critère",
  CRITERIA_WEIGHT: "Poids",
  CRITERIA_WEIGHT_FOR: "Poids de {criterion}",
  CRITERIA_SCORE_FOR: "Note du mode d'action {coa} pour {criterion}",
  CRITERIA_TOTAL: "Score pondéré",
  CRITERIA_RANK: "Rang",
  CRITERIA_TOTAL_OF: "{total} sur {max}",
  CRITERIA_MISSING: "{count} non notés",
  DECISION_EXPORT: "Exporter vers Word",
  DECISION_EXPORT_TITLE: "Aide à la décision",
  DECISION_EXPORT_DATE: "Exporté le {date}",
  DECISION_LOG: "Journal des décisions",
  DECISION_LOG_HINT: "Consignez les décisions prises et leur justification. Les entrées sont conservées si un scénario ou un mode d'action est supprimé.",
  DECISION_LOG_EMPTY: "Aucune décision consignée pour l'instant.",
  RECORD_DECISION: "Consigner une décision",
  EDIT_DECISION: "Modifier la décision",
  DELETE_DECISION: "Supprimer la décision",
  DECISION_LOG_DATE: "Date et heure",
  DECISION_LOG_SCENARIO: "Scénario",
  DECISION_LOG_DECISION: "Décision",
  DECISION_LOG_RATIONALE: "Justification",
  DECISION_LOG_AUTHOR: "Décidé par",
  DECISION_LOG_REMOVED: "supprimé",
  DECISION_LOG_NO_SCENARIO: "Aucun scénario particulier",
  DECISION_LOG_NO_COA: "Aucun mode d'action particulier",
  DECISION_LOG_EDITED: "modifié le {date}",
  CRITERIA_NOT_SCORED: "non noté",
  DECISION_PROMPT_TITLE: "Activer l'aide à la décision ?",
  DECISION_PROMPT_MSG: "Cette boîte contient des catégories de décision, comme des mesures que vous choisissez après avoir décrit la situation. Activez l'aide à la décision pour les choisir et les comparer.",
  DECISION_PROMPT_LATER_NOTE: "Vous pourrez modifier ce choix plus tard dans les paramètres.",
  DECISION_PROMPT_ENABLE: "Activer",
  DECISION_PROMPT_NOT_NOW: "Pas maintenant",
  PROBABILITY: "Probabilité d'occurrence",
  IMPACT: 'Impact',
  RISK: 'Risque',
  RISK_PLACEHOLDER: 'Probabilité x Impact',
  PROB5: {
    0: 'Très faible',
    1: 'Faible',
    2: 'Moyen',
    3: 'Élevé',
    4: 'Très élevé',
  },
  IMP5: {
    0: 'Très faible',
    1: 'Faible',
    2: 'Moyen',
    3: 'Élevé',
    4: 'Très élevé',
  },
  RISK5: {
    0: 'Très faible',
    1: 'Faible',
    2: 'Moyen',
    3: 'Élevé',
    4: 'Très élevé',
  },
  SUGGESTED_APPROACH: {
    TITLE: 'Approche suggérée',
    DESC: "L'approche suggérée est une combinaison (pondérée par le risque) des contre-mesures sélectionnées.",
  },
  TEMPLATE: {
    TITLE: 'Modèle de texte fluide',
    DESC: 'Rédigez un paragraphe où XXX est remplacé par la valeur du facteur clé 1, etc. Les lignes vides sont converties en paragraphes.',
  },
  SELECT_PERSONA: 'Sélectionner le persona pertinent pour le scénario',
  SELECT_PERSONA_HELP: 'Notez comment chaque persona sélectionné perçoit un scénario enregistré, réagit aux mesures et doit être informé ou impliqué.',
  PERSONA_IMPRESSION: 'Retour du persona',
  COPY_PERSONA_PROMPT: "Copier l’invite de retour",
  COPY_PERSONA_PROMPT_SHORT: 'Copier',
  COPY_PERSONA_PROMPT_FOR: "Copier l’invite de retour pour {persona}",
  GENERATE_PERSONA_FEEDBACK: 'Générer un retour',
  GENERATE_PERSONA_FEEDBACK_SHORT: 'Générer',
  GENERATE_PERSONA_FEEDBACK_FOR: 'Générer un retour pour {persona}',
  PERSONA_PROMPT_COPIED: "Invite de retour copiée. Collez-la dans le chat de votre assistant IA, puis collez la réponse dans ce champ.",
  PERSONA_PASTE_HINT: "Collez directement la réponse du LLM dans le champ ci-dessus ; elle est enregistrée automatiquement.",
  PERSONA_FEEDBACK_ERROR: "Impossible de générer ou de copier le retour. Réessayez.",
  PERSONA: {
    1: 'Persona',
    n: 'Personas',
  },
  IMAGE: 'Image',
  SAVE: 'Enregistrer',
  EDIT: 'Modifier',
  MARKDOWN_FIELD_EMPTY: "Cliquez pour ajouter du texte",
  LLM: 'LLM',
  SERVICE: 'Service',
  PROVIDER: 'Fournisseur',
  SYSTEM_PROMPT: 'Invite système',
  USER_PROMPT: 'Invite de récit',
  EFFECT_PROMPT: "Invite d'effet",
  PERSONA_PROMPT: 'Invite de persona',
  COMMUNICATIONS_PROMPT: 'Invite de communications',
  TEMPERATURE: {
    BTN: 'Température',
    DESC: 'À quel point le LLM doit-il être créatif (max = 1) ?',
  },
  API_KEY: 'Clé API',
  URL: 'URL',
  ASK_LLM: 'Demander au LLM',
  INCLUDE_LLM: 'Inclure dans le LLM',
  OLLAMA_URL:
    "Nom d'hôte (et port, optionnellement via un [proxy](https://github.com/erikvullings/proxy))",
  ADV_EDIT: 'Éditeur de code',
  TOGGLE: { SHOW: 'Afficher le tableau', HIDE: 'Masquer le tableau' },
  AUTO_CREATE: {
    BTN: 'Création automatique',
    COUNT: 'Nombre de créations automatiques LLM',
    COUNT_DESC: 'Combien de scénarios voulez-vous générer à la fois ?',
  },
  AUTO_CREATE_MSG: {
    1: `Créer automatiquement 1 scénario`,
    n: 'Créer automatiquement {n} scénarios',
  },
  COPY_BOX: {
    LABEL: 'Copier la boîte',
    TITLE: 'Copier le tableau dans le presse-papiers',
    TOAST: 'Boîte morphologique copiée dans le presse-papiers.',
  },
  PROMPT_TYPE: {
    PROMPTS: 'Invites',
    LABEL: "Type d'invite",
    NARRATIVE: 'Invite de récit',
    EFFECT: "Invite d'effet",
    PERSONA: 'Invite de persona',
    COM: 'Invite de communications',
    DECISION: "Invite de réflexion sur les décisions",
  },
  LLM_DEFAULT_NARRATIVE_PROMPT:
    'Utilisez les elements suivants pour definir un scenario realiste.',
  LLM_INCLUDED_CATEGORIES: 'Catégories incluses',
  LLM_PROMPT_TEXT: 'Invite',
  LLM_CATEGORY_REQUIRED: 'Sélectionnez au moins une catégorie pour cette invite.',
  LLM_DEFAULT_PERSONA_PROMPT:
    "Décrivez comment le persona ciblé perçoit cette situation, y compris les mesures proposées et, si pertinent, la façon de l’informer ou de l’impliquer. Appuyez-vous sur le scénario et les descriptions des personas ; n’inventez pas de détails. Renvoyez uniquement le retour du persona ciblé, prêt à être collé dans son champ. N’ajoutez ni titre, ni nom de persona, ni bloc de code.",
  LLM_PERSONA_CONTEXT: 'Personas sélectionnés et descriptions :\n{personas}',
  LLM_PERSONA_TARGET: 'Rédigez un retour uniquement pour : {persona}',
  LLM_SCENARIO_TEXT: 'Récit du scénario :\n{narrative}',
  LLM_SITUATION: "Situation (utilisez ces éléments pour décrire l’incident) :",
  LLM_SUGGESTED_ACTIONS: "Actions proposées (mesures à décrire et à évaluer) :",
  LLM_NO_MEASURES_SELECTED: "Aucune mesure n’a été sélectionnée : décrivez uniquement l’incident et n’inventez ni mesures ni solution.",
  LLM_DEFAULT_DECISION_PROMPT: "Vous êtes un conseiller expérimenté en gestion de crise. Évaluez la ligne d'action ci-dessous pour la situation donnée. Restez fidèle à la situation et au récit du scénario ; n'inventez pas de faits. Soyez concis : 250 mots au maximum, en Markdown, avec exactement ces parties : **Verdict** (2–3 phrases sur la pertinence, le calendrier et l'enchaînement), **Points forts** (2 puces), **Risques et lacunes** (2–3 puces, y compris ce qui manque) et **Amélioration** (1 recommandation concrète). N'ajoutez ni titre ni blocs de code.",
  LLM_DECISION_SITUATION: "Situation (l'incident auquel les décisions répondent) :",
  LLM_COA_DECISIONS: "Mode d'action {coa} : décisions à évaluer :",
  LLM_COA_NO_DECISIONS: "Aucune décision n'a encore été choisie pour le mode d'action {coa} : indiquez quelles décisions sont nécessaires.",
  LLM_OTHER_COAS: "Autres modes d'action envisagés (pour comparaison uniquement ; ne les évaluez pas) :",
  LLM_COMBINED_INTRO: "Réalisez toutes les tâches ci-dessous pour un scénario. Répondez par un seul objet JSON dans un bloc de code ```json, sans rien d'autre.",
  LLM_COMBINED_TASK_NARRATIVE: "Tâche : rédiger le récit du scénario",
  LLM_COMBINED_CURRENT_NARRATIVE: "Récit actuel (améliorez-le et gardez ce qui convient encore) :\n{narrative}",
  LLM_COMBINED_TASK_DECISIONS: "Tâche : évaluer chaque mode d'action",
  LLM_COMBINED_TASK_PERSONAS: "Tâche : rédiger un retour pour chaque persona, à partir de votre récit",
  LLM_COMBINED_OUTPUT: "Format de sortie (ces règles priment sur les consignes de mise en forme précédentes) : complétez le modèle JSON ci-dessous. Ne modifiez aucun id, mettez un titre court et descriptif dans \"title\", rédigez les textes en Markdown, utilisez \\n pour les retours à la ligne dans les chaînes et n'ajoutez ni autres champs ni texte hors du bloc de code.",
  COMBINED_PROMPT: "Prompt tout-en-un",
  COMBINED_PROMPT_TITLE: "Un seul prompt pour le récit, l'évaluation des modes d'action et les retours des personas ; recollez la réponse JSON",
  COMBINED_TITLE: "Prompt IA tout-en-un",
  COMBINED_HINT: "Le prompt est dans votre presse-papiers. Collez-le dans votre assistant IA (par exemple Copilot) et collez sa réponse JSON ci-dessous. Cette fenêtre reste ouverte pendant ce temps.",
  COMBINED_COPY: "Copier le prompt",
  COMBINED_COPIED: "Prompt copié. Collez la réponse JSON ci-dessous.",
  COMBINED_PASTE: "Réponse de l’IA (JSON)",
  COMBINED_PARSE_ERROR: "Aucun JSON valide trouvé dans cette réponse. Demandez à l'IA de ne renvoyer que le bloc de code JSON.",
  COMBINED_APPLY: "Appliquer",
  COMBINED_APPLIED: "Scénario mis à jour avec la réponse de l'IA.",
  COMBINED_UNMATCHED: "Non reconnu, ignoré : {names}",
  COMBINED_REPLACES: "remplace le texte existant",
  COMBINED_FIELD_TITLE: "Titre",
  COMBINED_FIELD_NARRATIVE: "Récit",
  COMBINED_HINT_API: "Générez la réponse avec le service d’IA configuré, ou copiez le prompt et collez la réponse JSON ci-dessous. Vérifiez le résultat avant de l’appliquer.",
  COMBINED_GENERATE: "Générer",
  COMBINED_GENERATE_ERROR: "Le service d’IA n’a pas répondu. Vérifiez les paramètres LLM ou copiez le prompt.",
  LLM_FIELD_PROMPTS: "Prompt par champ",
  LLM_FIELD_PROMPTS_DESC: "Le prompt tout-en-un reste disponible. Affichez aussi un bouton de prompt à côté du récit, de chaque évaluation et de chaque persona, pour (re)générer uniquement cette partie.",
  AI_NARRATIVE: "Demander au LLM : rédiger le récit",
  COPY_NARRATIVE_PROMPT: "Copier le prompt du récit",
  NARRATIVE_PASTE_HINT: "Copiez le prompt, interrogez votre assistant IA et collez sa réponse dans le champ du récit.",
  NARRATIVE_GENERATE_ERROR: "Impossible de générer le récit. Vérifiez les paramètres LLM.",
  RESPONSE_INSTRUCTIONS:
    'Commencez votre réponse par un titre court et descriptif sur sa propre ligne, puis une ligne vide, puis le contenu principal.',
  WIZARD_STEP1_TITLE: 'Informations sur la boîte',
  WIZARD_STEP1_SUBTITLE: 'Nommez et décrivez votre boîte',
  WIZARD_STEP2_TITLE: 'Facteurs clés',
  WIZARD_STEP2_SUBTITLE:
    'Définissez la catégorie morphologique et les facteurs clés',
  WIZARD_STEP3_TITLE: 'Options des facteurs',
  WIZARD_STEP3_SUBTITLE:
    'Ajoutez optionnellement des options pour chaque facteur',
  WIZARD_CATEGORY_INFO: 'Détails de la catégorie',
  WIZARD_COMPONENTS_INFO: 'Facteurs clés (dimensions)',
  WIZARD_VALUES_INFO: 'Sélectionnez un facteur pour ajouter des options :',
  WIZARD_NO_COMPONENTS:
    "Aucun facteur défini pour le moment. Retournez à l'étape 2.",
  WIZARD_VALUES_FOR_COMPONENT: 'Options pour {component}',
  WIZARD_DEFAULT_CATEGORY_NAME: 'Boîte Morphologique Initiale',
  WIZARD_NEXT: 'Suivant',
  WIZARD_PREVIOUS: 'Retour',
  WIZARD_COMPLETE: 'Créer la boîte',
  WIZARD_SKIP: 'Passer',
  LLM_WIZARD_TITLE: "Créer une boîte avec l'IA",
  LLM_WIZARD_STEP1_TITLE: 'Définir les exigences',
  LLM_WIZARD_STEP1_SUBTITLE: 'Spécifiez ce que vous voulez générer',
  LLM_WIZARD_STEP1_DESC:
    'Remplissez les détails ci-dessous pour personnaliser la génération de votre boîte morphologique :',
  LLM_WIZARD_STEP2_TITLE: "Réviser l'invite",
  LLM_WIZARD_STEP2_SUBTITLE: "Révisez et modifiez l'invite complète",
  LLM_WIZARD_STEP2_DESC:
    "Révisez l'invite combinée ci-dessous. Vous pouvez la modifier si nécessaire :",
  LLM_WIZARD_STEP3_TITLE: 'Configurer le LLM',
  LLM_WIZARD_STEP3_SUBTITLE: 'Choisissez le service LLM et les paramètres',
  LLM_WIZARD_STEP3_DESC:
    'Configurez comment vous voulez générer la boîte morphologique :',
  LLM_WIZARD_STEP4_TITLE: 'Générer la boîte',
  LLM_WIZARD_STEP4_SUBTITLE: 'Générez ou collez le résultat',
  LLM_WIZARD_STEP4_CLIPBOARD_DESC:
    "L'invite est prête. Copiez-la et utilisez un LLM externe pour générer la boîte morphologique :",
  LLM_PURPOSE: 'Objectif',
  LLM_PURPOSE_HELP:
    'Que voulez-vous explorer ou concevoir ? Par exemple, "scénarios de gestion de crise pour la planification d\'urgence nationale"',
  LLM_DOMAIN: 'Domaine',
  LLM_DOMAIN_HELP:
    'Spécifiez le domaine ou le contexte, par exemple, "réponse aux catastrophes", "cybersécurité", "opérations militaires"',
  LLM_OUTPUT_TYPE: 'Type de sortie',
  LLM_OUTPUT_TYPE_HELP:
    'Une boîte morphologique, plusieurs boîtes, axé sur les scénarios, axé sur les mesures, ou les deux ?',
  LLM_CONSTRAINTS: "Contraintes ou domaines d'intérêt",
  LLM_CONSTRAINTS_HELP:
    'Par exemple, "Inclure les facteurs socio-politiques, environnementaux et technologiques"',
  LLM_DETAIL_DEPTH: 'Niveau de détail',
  LLM_DETAIL_DEPTH_HELP:
    'Par exemple, "Inclure 6-7 options détaillées par facteur, chacune avec une définition en une phrase"',
  LLM_LANGUAGE: 'Langue de sortie',
  LLM_LANGUAGE_HELP:
    'La langue pour le contenu généré, par exemple, "Anglais", "Français"',
  LLM_FULL_PROMPT: 'Invite complète',
  LLM_ENDPOINT: 'Méthode de génération',
  LLM_CLIPBOARD: 'Copier dans le presse-papiers (utiliser un LLM externe)',
  LLM_OLLAMA: 'Générer avec Ollama',
  LLM_OPENAI: 'Générer avec OpenAI',
  LLM_OLLAMA_URL_HELP:
    "URL de l'API Ollama, par exemple, http://localhost:11434/api/chat",
  LLM_OPENAI_URL_HELP: "URL de l'API OpenAI (laisser vide par défaut)",
  LLM_OLLAMA_MODEL_HELP: 'Nom du modèle, par exemple, gemma2, llama3, qwen2.5',
  LLM_OPENAI_MODEL_HELP: 'Nom du modèle, par exemple, gpt-4o-mini, gpt-4o',
  LLM_COPY_PROMPT: "Copier l'invite dans le presse-papiers",
  TEMPLATE_PROMPT_COPIED: 'Invite de modèle copiée dans le presse-papiers',
  TEMPLATE_PROMPT_COPY: "Copier l'invite LLM dans le presse-papiers",
  LLM_PROMPT_COPIED: 'Invite copiée dans le presse-papiers !',
  LLM_PASTE_OUTPUT: 'Collez la sortie du LLM ci-dessous :',
  LLM_GENERATE: 'Générer avec le LLM',
  LLM_GENERATING: 'Génération avec le LLM...',
  LLM_ERROR: 'Erreur de génération',
  INCLUDE_MAP_SUPPORT: 'Activer le support de carte',
  SETTINGS_GENERAL: "Général",
  SETTINGS_OPTIONS: "Options",
  SETTINGS_NARRATIVE: "Récit",
  SETTINGS_MAP: "Carte",
  SETTINGS_STRUCTURE: "Structure de la boîte",
  HIDE_INCONSISTENT_HINT: "Lors de la création d'un scénario, masquer les options impossibles avec votre sélection, au lieu de simplement les signaler.",
  INCLUDE_MAP_SUPPORT_HINT: "Afficher une carte lors de la définition de la boîte ainsi que lors de la création et de la consultation des scénarios, pour situer les facteurs.",
  INCLUDE_DECISION_SUPPORT_HINT: "Afficher les catégories de mesures, les options d'action et la page de décision.",
  MAP_CONFIG: 'Configuration de la carte',
  MAP_UNITS: 'Unités de la carte',
  METRIC: 'Métrique',
  IMPERIAL: 'Impérial',
  OSM_AMENITIES: 'Équipements OSM',
  TOGGLE_MAP: 'Afficher/masquer la carte',
  ZOOM_LEVEL: 'Niveau de zoom',
  CIRCLE: 'Cercle',
  ELLIPSE: 'Ellipse',
  OSM_QUERY: 'Requête OSM',
  RADIUS: 'Rayon (m)',
  RADII: 'Rayons (séparés par des virgules, en mètres)',
  MAJOR_AXIS: 'Grand axe (m)',
  MINOR_AXIS: 'Petit axe (m)',
  ORIENTATION: 'Orientation',
  ORIENTATION_DESC: 'Angle en degrés (0 = Nord) ou ID de référence',

  LLM_GENERATED_MARKDOWN: 'Markdown généré',

  IMPORT_FROM_SPREADSHEET: 'Coller depuis une feuille de calcul',
  IMPORT_PASTE_DATA: 'Coller les données de la feuille de calcul',
  IMPORT_PLACEHOLDER:
    "Collez ici les données séparées par des tabulations d'Excel/Google Sheets...\n\nPremière ligne = noms des facteurs clés, chaque colonne = options pour ce facteur.",
  IMPORT_PARSE: 'Analyser et importer',
  IMPORT_NO_DATA: 'Aucune donnée tabulaire détectée. Collez un tableau et réessayez.',
  IMPORT_NO_DRIVERS: 'Aucun facteur clé détecté. Vérifiez les données collées.',
  IMPORT_NEEDS_TWO_COLUMNS:
    "L'import nécessite au moins 2 colonnes (noms des facteurs clés et options).",
  CLOSE_MESSAGE: 'Fermer le message',
  SEARCH_SCENARIO_TYPE: 'Rechercher un type de scénario…',
  NO_SCENARIO_TYPE_FOUND: 'Aucun type de scénario trouvé',
  COVERAGE_MENU: "Générer un ensemble couvrant…",
  COVERAGE_TITLE: "Générer des scénarios qui couvrent la boîte",
  COVERAGE_DESC: "Crée des scénarios distincts dans lesquels chaque option est utilisée à peu près aussi souvent, au lieu de les choisir au hasard. Les options verrouillées sont conservées, les combinaisons impossibles ne sont jamais utilisées et les improbables sont évitées. Les scénarios inclus existants comptent pour l'équilibre.",
  COVERAGE_COUNT: "Nombre de scénarios",
  COVERAGE_BATCH_NAME: "Nom du lot (préfixe des noms de scénario)",
  COVERAGE_BATCH_DEFAULT: "Lot",
  COVERAGE_PAIRS: "Répartir aussi les combinaisons d'options (par paires)",
  COVERAGE_START: "Générer",
  COVERAGE_STOP: "Arrêter",
  COVERAGE_PROGRESS: "{done} sur {total} scénarios",
  COVERAGE_DONE: "{count} scénarios ajoutés à « {batch} »",
  COVERAGE_EXHAUSTED: "Seuls {count} nouveaux scénarios distincts et cohérents ont pu être créés.",
  DELETE_BATCH_MENU: "Supprimer un lot généré…",
  DELETE_BATCH_TITLE: "Supprimer un lot de scénarios générés",
  DELETE_BATCH_SELECT: "Lot",
  DELETE_BATCH_KEEP_TEXT: "Conserver les scénarios qui ont déjà un récit",
  DELETE_BATCH_DONE: "{count} scénarios supprimés",
  SHOW_GENERATED: "Afficher {count} scénarios générés sans récit",
};
